import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3500"
    : "https://sumanu-api.onrender.com";

export const apiSlice = createApi({
  reducerPath: "api", // optional
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["Project", "Issue", "Comment", "User"],
  endpoints: (builder) => ({}),
});
